import { render, staticRenderFns } from "./common-list.vue?vue&type=template&id=d85a537e&scoped=true&"
import script from "./common-list.vue?vue&type=script&lang=js&"
export * from "./common-list.vue?vue&type=script&lang=js&"
import style0 from "./common-list.vue?vue&type=style&index=0&id=d85a537e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85a537e",
  null
  
)

export default component.exports